export const isLocalUrl = (urlInput: string) => {
  try {
    const url = new URL(urlInput);
    return (
      url.hostname === '127.0.0.1' ||
      url.hostname === 'staging-local-studio.apollographql.com' ||
      url.hostname === 'prod-local-studio.apollographql.com' ||
      url.hostname === 'dev0-local-studio.apollographql.com' ||
      url.href.includes('localhost')
    );
  } catch {
    return false;
  }
};
